export default "__VITE_ASSET__jHNzEhaB__"